import React, { useEffect, useState } from 'react'
import './topbar.css'
import LogoComponent from '../logoComponent/logoComponent'
import {useSelector,useDispatch} from 'react-redux';
import { setLanguage, setContactusPopup } from '../../lib/redux/rootReducer';
import Hamburger from 'hamburger-react'

const TopbarComponent = ({isDarkMode,selectedTab,setSelectedTab}) => {
    const languageSelected = useSelector((state) => state.language.value)
    const dispatch = useDispatch()
    const [isOpen, setOpen] = useState(false)

    const topbarTabs = [
        {label:'Studio',id:'studio'},
        {label:'Solutions',id:'solutions'},
        {label:'Our Process',id:'our_process'},
        {label:'Contact',id:'contact'}
    ]
    
    useEffect(() => {
        document.addEventListener('scroll',e=>{
            if(window.scrollY>0){
                document.getElementById('topbarContainer').style.background = 'black'
            }
        })
        
        return () => {
            document.removeEventListener('scroll',e=>{
                if(window.scrollY>0){
                    document.getElementById('topbarContainer').style.background = 'black'
                }
            })
        }
    }, [])
    
    const scrollSmoothToView = (componentId) => {
        var elmntToView = document.getElementById(componentId);
        if(elmntToView){
            window.scrollTo({
                top: elmntToView.offsetTop-150,
                behavior:'smooth'
            }); 
        }
    }

    const redirectionFunction = (componentId) => {
        setOpen(false)
        setSelectedTab(componentId);
        if(componentId==='contact'){
            dispatch(setContactusPopup(true))
        }
        else{
            scrollSmoothToView(componentId)
        }
    }
    const tabItemsRender = () => {
        return topbarTabs.map((item,index)=>{
            return <div className='tabItem' style={selectedTab===item.id ? {color:'var(--logo-color)'} : {}} key={index} onClick={()=>{redirectionFunction(item.id)}}>
                {item.label.toUpperCase()}
            </div>
        })
    }

    return (
        <>
            <div className='topbar' id='topbarContainer'>
                <div onClick={()=>{redirectionFunction('home')}}><LogoComponent isDarkMode={isDarkMode}/></div>
                <div className='tabsRow'>
                    {tabItemsRender()}
                </div>
                <div className='topbarHamburger'>
                    <Hamburger toggled={isOpen} toggle={setOpen} />
                </div>
                <select className='languageSelector' value={languageSelected} onChange={(e)=>{dispatch(setLanguage(e.target.value));}}>
                    <option value={'en'}>English</option>
                    <option value={'hi'}>Hindi</option>
                </select>
            </div>

            <div className={isOpen ? 'topbarHamburgerMenu topbarHamburgerMenuOpened' : 'topbarHamburgerMenu'}>
                {tabItemsRender()}
            </div>
        </>
    )
}

export default TopbarComponent